import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AdminMenuService } from '../shared/service/admin-menu.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Menu, Heading, SubMenuLinks } from '../shared/model/menu';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
declare var $: any;
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';
@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.css']
})
export class AdminMenuComponent implements OnInit {

  menuArr = [];
  dataSource: any;
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['Title', 'Edit', 'Delete'];
  LocalToken: string = '';
  headingArr = [];
  headingdataSource: any;
  @ViewChild('paginator2') headingPaginator: MatPaginator;
  @ViewChild(MatSort) headingSort: MatSort;
  headingDisplayedColumns: string[] = ['Title', 'Menu', 'Edit', 'Delete'];

  submenulinksArr = [];
  submenulinksdataSource: any;
  @ViewChild('paginator3') submenulinksPaginator: MatPaginator;
  @ViewChild(MatSort) submenulinksSort: MatSort;
  submenulinksDisplayedColumns: string[] = ['Title', 'Heading', 'Menu', 'Edit', 'Delete'];

  constructor(private adminMenuService: AdminMenuService, private dialog: MatDialog, private router: Router,private autoLogoutService: AutoLogoutService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
   }

  ngOnInit() {
  }

  /**
   * Set the paginator after the view init since this component will
   * be able to query its view for the initialized paginator.
   */
  ngAfterViewInit() {
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getAllMenu();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }

  }

  _setDataSource(indexNumber) {
    console.log(indexNumber);
    setTimeout(() => {
      switch (indexNumber) {
        case 0:
          // this.getMenu()
          !this.dataSource.paginator ? this.dataSource.paginator = this.paginator : null;
          break;
        case 1:
          // this.getHeading();
          !this.headingdataSource.paginator ? this.headingdataSource.paginator = this.headingdataSource : null;
          break;
        case 2:
          // this.getSubMenuLinks();
          !this.submenulinksdataSource.paginator ? this.submenulinksdataSource.paginator = this.submenulinksdataSource : null;
          break;
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilterHeading(filterValue: string) {
    this.headingdataSource.filter = filterValue.trim().toLowerCase();

    if (this.headingdataSource.paginator) {
      this.headingdataSource.paginator.firstPage();
    }
  }

  applyFilterSubMenuLinks(filterValue: string) {
    this.submenulinksdataSource.filter = filterValue.trim().toLowerCase();

    if (this.submenulinksdataSource.paginator) {
      this.submenulinksdataSource.paginator.firstPage();
    }
  }



  getAllMenu() {
    this.adminMenuService
      .getMenu()
      .then((result) => {
        this.menuArr = result;
        this.dataSource = new MatTableDataSource(this.menuArr);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.adminMenuService
          .getHeading()
          .then((result) => {
            this.headingArr = result;
            for (var i = 0; i < this.headingArr.length; i++) {
              let resultOfFilter = this.menuArr.filter(x => x.Id == this.headingArr[i].Menu)[0];
              if (resultOfFilter) {
                this.headingArr[i].Menu = resultOfFilter.Title;
              }
            }
            this.headingdataSource = new MatTableDataSource(this.headingArr);
            this.headingdataSource.paginator = this.headingPaginator;
            this.headingdataSource.sort = this.headingSort;

            this.adminMenuService
              .getSubMenuLinks()
              .then((result) => {
                this.submenulinksArr = result;
                for (var i = 0; i < this.submenulinksArr.length; i++) {
                  let resultOfFilter = this.headingArr.filter(x => x.Id == this.submenulinksArr[i].Menu)[0];
                  if (resultOfFilter) {
                    this.submenulinksArr[i].Heading = resultOfFilter.Title;
                  }
                }
                for (var i = 0; i < this.submenulinksArr.length; i++) {
                  let resultOfFilter = this.menuArr.filter(x => x.Id == this.submenulinksArr[i].Menu)[0];
                  if (resultOfFilter) {
                    this.submenulinksArr[i].Menu = resultOfFilter.Title;
                  }
                }
                this.submenulinksdataSource = new MatTableDataSource(this.submenulinksArr);
                this.submenulinksdataSource.paginator = this.submenulinksPaginator;
                this.submenulinksdataSource.sort = this.submenulinksSort;
              })
              .catch((err) => console.log(err));

          })
          .catch((err) => console.log(err));

      })
      .catch((err) => console.log(err));
  }


  // Menu
  getMenu() {
    this.adminMenuService
      .getMenu()
      .then((result) => {
        this.menuArr = result;
        this.dataSource = new MatTableDataSource(this.menuArr);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
      .catch((err) => console.log(err));
  }

  deleteMenu(ID) {
    console.log(this.menuArr, ID);
    if (this.menuArr.length > 0) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.adminMenuService
          .deleteMenu(ID)
          .then((result) => this.getMenu())
          .catch((err) => console.log(err));
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(AdminMenuDialog, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getMenu();
    });
  }

  editDialog(obj) {
    const dialogRef = this.dialog.open(AdminMenuDialog, {
      width: '1000px',
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getMenu();
    });
  }




  // Heading
  getHeading() {
    this.adminMenuService
      .getHeading()
      .then((result) => {
        this.headingArr = result;
        for (var i = 0; i < this.headingArr.length; i++) {
          let resultOfFilter = this.menuArr.filter(x => x.Id == this.headingArr[i].Menu)[0];
          this.headingArr[i].Menu = resultOfFilter.Title;
        }
        this.headingdataSource = new MatTableDataSource(this.headingArr);
        console.log("headingdataSource", this.headingdataSource);
        this.headingdataSource.paginator = this.headingPaginator;
        this.headingdataSource.sort = this.headingSort;
      })
      .catch((err) => console.log(err));
  }

  deleteHeading(ID) {
    console.log(this.headingArr, ID);
    if (this.headingArr.length > 0) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.adminMenuService
          .deleteHeading(ID)
          .then((result) => this.getHeading())
          .catch((err) => console.log(err));
      }
    }
  }

  openHeadingDialog() {
    const dialogRef = this.dialog.open(HeadingDialog, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getHeading();
    });
  }

  editHeadingDialog(obj) {
    const dialogRef = this.dialog.open(HeadingDialog, {
      width: '1000px',
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getHeading();
    });
  }


  // SubMenuLinks
  getSubMenuLinks() {
    this.adminMenuService
      .getSubMenuLinks()
      .then((result) => {
        this.submenulinksArr = result;
        for (var i = 0; i < this.submenulinksArr.length; i++) {
          let resultOfFilter = this.menuArr.filter(x => x.Id == this.submenulinksArr[i].Menu)[0];
          if (resultOfFilter) {
            this.submenulinksArr[i].Menu = resultOfFilter.Title;
          }
        }
        for (var i = 0; i < this.submenulinksArr.length; i++) {
          let resultOfFilter = this.headingArr.filter(x => x.Id == this.submenulinksArr[i].Heading)[0];
          if (resultOfFilter) {
            this.submenulinksArr[i].Heading = resultOfFilter.Title;
          }
        }
        this.submenulinksdataSource = new MatTableDataSource(this.submenulinksArr);
        this.submenulinksdataSource.paginator = this.submenulinksPaginator;
        this.submenulinksdataSource.sort = this.submenulinksSort;
      })
      .catch((err) => console.log(err));
  }

  deleteSubMenuLinks(ID) {
    console.log(this.submenulinksArr, ID);
    if (this.submenulinksArr.length > 0) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.adminMenuService
          .deleteSubMenuLinks(ID)
          .then((result) => this.getSubMenuLinks())
          .catch((err) => console.log(err));
      }
    }
  }

  openSubMenuLinksDialog() {
    const dialogRef = this.dialog.open(SubMenuLinksDialog, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getSubMenuLinks();
    });
  }

  editSubMenuLinksDialog(obj) {
    const dialogRef = this.dialog.open(SubMenuLinksDialog, {
      width: '1000px',
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getSubMenuLinks();
    });
  }


}


//******************************* */ menu Dialoag Component
@Component({
  selector: 'menu-dialog',
  templateUrl: 'menu-dialog.html',
})
export class AdminMenuDialog {
  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<AdminMenuDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Menu, private adminMenuService: AdminMenuService) {
    if (this.data.Id) {
      this.isUpdate = true;
    }
  }

  addMenu() {
    this.blockUI.start('Please wait...');
    this.data.Title = (this.data.Title).toUpperCase();
    this.adminMenuService
      .addMenu(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close();
      })
      .catch((err) => this.errorHandler(err));
  }

  editMenu() {
    this.blockUI.start('Please wait...');
    this.data.Title = (this.data.Title).toUpperCase();
    this.adminMenuService
      .editMenu(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close();
      })
      .catch((err) => this.errorHandler(err));
  }

  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }
}


//******************************* */ heading Dialoag Component
@Component({
  selector: 'heading-dialog',
  templateUrl: 'heading-dialog.html',
})
export class HeadingDialog {
  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;
  menuArr: Menu[] = [];
  constructor(
    public dialogRef: MatDialogRef<HeadingDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Heading, private adminMenuService: AdminMenuService) {
    this.getMenu();
    if (this.data.Id) {
      this.isUpdate = true;
    }
  }

  getMenu() {
    this.adminMenuService
      .getMenu()
      .then((result) => {
        console.log(result);
        this.menuArr = result;
        if (this.data.Id) {
          // this.data.Menu = "";
          let resultOfFilter = this.menuArr.filter(x => x.Title.toString() == this.data.Menu)[0];
          console.log(resultOfFilter);
          if (resultOfFilter) {
            this.data.Menu = resultOfFilter.Id;
          }
        }
      })
      .catch((err) => console.log(err));
  }

  addHeading() {
    this.blockUI.start('Please wait...');
    this.data.Title = (this.data.Title).toUpperCase();
    this.adminMenuService
      .addHeading(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close();
      })
      .catch((err) => this.errorHandler(err));
  }

  editHeading() {
    this.blockUI.start('Please wait...');
    this.data.Title = (this.data.Title).toUpperCase();
    this.adminMenuService
      .editHeading(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close();
      })
      .catch((err) => this.errorHandler(err));
  }

  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }
}



//******************************* */ SubMenuLinks Dialoag Component
@Component({
  selector: 'sub-menu-links-dialog',
  templateUrl: 'sub-menu-links-dialog.html',
})
export class SubMenuLinksDialog {
  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;
  menuArr: Menu[] = [];
  headingArr: Heading[] = [];
  constructor(
    public dialogRef: MatDialogRef<SubMenuLinksDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SubMenuLinks, private adminMenuService: AdminMenuService) {
    this.getMenu();
    this.getHeading();
    if (this.data.Id) {
      this.isUpdate = true;
    }
    else {
      this.data.Menu = "";
      this.data.Heading = "";
    }
  }

  getMenu() {
    this.adminMenuService
      .getMenu()
      .then((result) => {
        console.log(result);
        this.menuArr = result;
        if (this.data.Id) {
          let resultOfFilter = this.menuArr.filter(x => x.Title.toString() == this.data.Menu)[0];
          console.log(resultOfFilter);
          if (resultOfFilter) {
            this.data.Menu = resultOfFilter.Id;
          }
        }
      })
      .catch((err) => console.log(err));
  }

  getHeading() {
    this.adminMenuService
      .getHeading()
      .then((result) => {
        this.headingArr = result;
        if (this.data.Id) {
          let resultOfFilter = this.headingArr.filter(x => x.Title.toString() == this.data.Heading)[0];
          console.log(resultOfFilter);
          if (resultOfFilter) {
            this.data.Heading = resultOfFilter.Id;
          }
        }
      })
      .catch((err) => console.log(err));
  }

  addSubMenuLinks() {
    this.blockUI.start('Please wait...');
    this.data.Title = (this.data.Title).toUpperCase();
    this.adminMenuService
      .addSubMenuLinks(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close();
      })
      .catch((err) => this.errorHandler(err));
  }

  editSubMenuLinks() {
    this.blockUI.start('Please wait...');
    this.data.Title = (this.data.Title).toUpperCase();
    this.adminMenuService
      .editSubMenuLinks(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close();
      })
      .catch((err) => this.errorHandler(err));
  }

  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }
}